import { render } from "./baseHtmlBlock.vue?vue&type=template&id=835e67ee&ts=true"
import script from "./baseHtmlBlock.vue?vue&type=script&lang=ts"
export * from "./baseHtmlBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__